export default "__VITE_ASSET__BuNWSSer__"